import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'superflex-confirmar-btn',
    template: `
        <p-button
            label="{{'BOTONES.btnConfirmar' | translate}}"
            icon="icon"
            iconPos="right"
            [styleClass]="styleClass"
            [class]="class"
            [type]="'submit'"
            (onClick)="onClick.emit()"
            [disabled]="isDisabled">
        </p-button>`,
})
export class ConfirmarBtnComponent {

    @Input() isDisabled: boolean;
    @Output() onClick = new EventEmitter<any>();
    @Input() icon = '';
    @Input() styleClass = 'p-mr-2';
    @Input() class = '';

    constructor() {/***/}
}
